document.addEventListener("DOMContentLoaded", function(e) {
  var productRecommendationsSection = document.querySelector(".gh-new-product-recommendations .product-recommendations");
  if (productRecommendationsSection) {
    var url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          // init swiper slider
          var recommendationsSlider = new Swiper(".gh-new-product-recommendations .product-recommendations__slider", {
            direction: "horizontal",
            slidesPerView: 1,
            spaceBetween: 16,
            pagination: {
              el: productRecommendationsSection.querySelector(".product-recommendations__pagination"),
              clickable: true,
            },
            breakpoints: {
              500: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              750: {
                slidesPerView: 3,
                spaceBetween: 32,
              }
            },
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
  
})